import TemplateView from "../../TemplateView";
import UserTime from "../../user_time";
import WorkflowStatusTimeRow from "./WorkflowStatusTimeRow";

export default class WorkflowStatusTimeColumn extends TemplateView {
    constructor() {
        super();

        this.state = {
            statuses: [],
            time: {},
            totalTime: 0,
            title: ""
        }

        this.onStateChanged(() => this.updateView());
    }

    templateHtml() {
        return "<div class='workflowTimeColumn'>" +
               "  <div class='totalRow'>" +
               "    <div class='title'></div>" +
               "    <div class='time'></div>" +
               "  </div>" +
               "  <div class='rowsContainer'></div>" +
               "</div>";
    }

    afterRender() {
        this.$rowsContainer = this.find(".rowsContainer");
        this.$totalTitle = this.find(".totalRow .title");
        this.$totalTime = this.find(".totalRow .time");
    }

    updateView() {
        this.$totalTitle.text(this.state.title);
        this.$totalTime.text(UserTime.formatTimeWithDigitSeparator(this.state.totalTime));
        this.createRows();
    }

    createRows() {
        this.$rowsContainer.empty();
        for (let i = 0; i < this.state.statuses.length; ++i) {
            const status = this.state.statuses[i];
            const time = this.state.time[status.id];
            if (!_.isUndefined(time)) {
                this.$rowsContainer.append("<div class='row status" + status.id + "'></div>");
                new WorkflowStatusTimeRow({
                    statusName: status.name,
                    statusType: status.type,
                    statusColorId: status.colorId,
                    time: time
                }).init(this.find(".rowsContainer .status" + status.id));
            }
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/project/WorkflowStatusTimeColumn.js